import axios from '../axiosConfig';
import {START_FETCH_COUNTRIES,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_COUNTRIES_FAILED } from "./types";

export const fetchCountries = () => {
    return async (dispatch) => {
        dispatch({
            type: START_FETCH_COUNTRIES,
        });
        try {
            const res = await axios.get(`/countries`);
            console.log('response',res);
            if (res.statusText == "OK") {
                // console.log("status ok!!!", res.data);
                dispatch({
                    type: FETCH_COUNTRIES_SUCCESS,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: FETCH_COUNTRIES_FAILED,
                    payload: res.data,
                });
            }
        } catch (error) {
            // console.log(error);
            dispatch({
                type: FETCH_COUNTRIES_FAILED,
                payload: error,
            });
        }
    };
};

